// extracted by mini-css-extract-plugin
export default {"header":"style_header__UIW0Q","icon":"style_icon__WFj-O","cell":"style_cell__MTYDF","container":"style_container__hD4Ly","footer":"style_footer__R7AXE"};